import { get, post, put, del } from "../request";

const PREFIX = "/contentAdmin/newsInfoAdmin";

/** 分页查询新闻资讯 */
export function getNewsList(params) {
  return get(`${PREFIX}/list`, params);
}

/** 新闻详情 */
export function getNewsDetail(newsId) {
  return get(`${PREFIX}/${newsId}`);
}

/** 新增新闻资讯 */
export function addNews(data) {
  return post(PREFIX, data);
}

/** 修改新闻资讯 */
export function updateNews(data) {
  return put(PREFIX, data);
}

/** 删除新闻资讯 */
export function deleteNews(newsIds) {
  return del(`${PREFIX}/${newsIds}`);
}



// WEBPACK FOOTER //
// ./src/api/content/news.js